import React from "react";
import { useReadOnly } from "slate-react";
import { SocialMedias as SupportedSocialMedias } from "../inputs/SocialMediasInput";
import EditSocialMediasButton from "../toolbar/EditSocialMediasButton";

export default function SocialMedias({ attributes, element, children }) {
  const readOnly = useReadOnly();
  const { socialMedias } = element;

  if (!Array.isArray(socialMedias)) {
    return null;
  }

  if (socialMedias.length === 0) {
    return null;
  }

  return (
    <div {...attributes}>
      <div
        css={{
          display: "none",
          userSelect: "none",
        }}
      >
        {children}
      </div>
      <div contentEditable={false}>
        <div
          css={{
            display: "grid",
            gridRowGap: 16,
            gridColumnGap: 8,
            gridTemplateColumns: "repeat(auto-fit, 32px)",
            position: "relative",
          }}
        >
          {socialMedias
            .map(({ socialMedia, url }) => {
              if (SupportedSocialMedias[socialMedia]) {
                const Icon = SupportedSocialMedias[socialMedia].icon;

                if (Icon) {
                  return (
                    <a
                      key={socialMedia}
                      href={url}
                      rel="noopener noreferrer"
                      target="_blank"
                      title={SupportedSocialMedias[socialMedia].name}
                      css={{
                        display: "inline-flex",
                        userSelect: "none",
                        "& > svg": {
                          display: "block",
                        },
                      }}
                    >
                      <Icon {...SupportedSocialMedias[socialMedia].iconProps} />
                    </a>
                  );
                }
              }

              return null;
            })
            .filter(Boolean)}

          {!readOnly && <EditSocialMediasButton element={element} />}
        </div>
      </div>
    </div>
  );
}
